<ng-template ngFor let-fields [ngForOf]="visibleFields">
  <div
    [class.multi-columns]="!fields.isFullWidth && isMultiColumn"
    [style.--column-count]="fields.isFullWidth ? 1 : groupColCount"
  >
    <ng-template ngFor let-field [ngForOf]="fields.fields">
      <div
        *ngIf="!(field.hiddenObs && (field.hiddenObs | async))"
        class="widget-wrapper"
        [ngClass]="field.wrapperClass"
      >
        <xvi-form-widget
          *ngIf="field.widgetFamily !== 'xux'; else xuxBlock"
          [field]="field"
          [control]="field.control"
        ></xvi-form-widget>
        <ng-template #xuxBlock>
          <xux-dynamic-widget
            #groupWidgets
            [field]="field"
            [dynamicWidgetsMap]="dynamicWidgetsMap"
            [attr.data-schema-path]="field.path"
            [attr.data-widget-type]="field.widget"
          ></xux-dynamic-widget>
        </ng-template>
      </div>
    </ng-template>
  </div>
</ng-template>
